import type { LexicalEditor, NodeKey } from 'lexical';

/**
 * One character's on-screen box (e.g. a typed `@` or `/`), by its text node and offset.
 * - Measured on every call, since the text node's element can be replaced.
 */
export const characterRect = (editor: LexicalEditor, key: NodeKey, offset: number): DOMRect => {
  const element = editor.getElementByKey(key);
  if (!element) return new DOMRect();
  const text = document.createTreeWalker(element, NodeFilter.SHOW_TEXT).nextNode();
  if (!text || (text.textContent?.length ?? 0) <= offset) return element.getBoundingClientRect();
  const range = document.createRange();
  range.setStart(text, offset);
  range.setEnd(text, offset + 1);
  return range.getBoundingClientRect();
};
